// Category options for keyword management
const categoryOptions = [
  // Main Categories
  { header: 'Main Categories' },
  { value: 'finance', label: 'Finance' },
  { value: 'health', label: 'Health' },
  { value: 'technology', label: 'Technology' },
  { value: 'education', label: 'Education' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'travel', label: 'Travel' },
  { value: 'shopping', label: 'Shopping' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'food', label: 'Food & Dining' },
  { value: 'sports', label: 'Sports' },
  { value: 'news', label: 'News' },
  { value: 'business', label: 'Business' },
  { value: 'lifestyle', label: 'Lifestyle' },
  
  // SEO-Specific Categories
  { header: 'SEO Categories' },
  { value: 'informational', label: 'Informational' },
  { value: 'navigational', label: 'Navigational' },
  { value: 'transactional', label: 'Transactional' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'local', label: 'Local' },
  { value: 'long_tail', label: 'Long Tail' },
  { value: 'branded', label: 'Branded' },
  { value: 'competitor', label: 'Competitor' },
  { value: 'seasonal', label: 'Seasonal' },
  { value: 'trending', label: 'Trending' },
  { value: 'question', label: 'Question' },
  { value: 'how_to', label: 'How-To' },
  { value: 'comparison', label: 'Comparison' },
  { value: 'review', label: 'Review' },
  
  // ISO Categories
  { header: 'ISO Categories' },
  { value: 'iso_01', label: 'Agriculture, Forestry & Fishing' },
  { value: 'iso_02', label: 'Mining & Quarrying' },
  { value: 'iso_03', label: 'Manufacturing' },
  { value: 'iso_04', label: 'Electricity, Gas & Air Conditioning' },
  { value: 'iso_05', label: 'Water Supply & Waste Management' },
  { value: 'iso_06', label: 'Construction' },
  { value: 'iso_07', label: 'Wholesale & Retail Trade' },
  { value: 'iso_08', label: 'Transportation & Storage' },
  { value: 'iso_09', label: 'Accommodation & Food Service' },
  { value: 'iso_10', label: 'Information & Communication' },
  { value: 'iso_11', label: 'Financial & Insurance Activities' },
  { value: 'iso_12', label: 'Real Estate Activities' },
  { value: 'iso_13', label: 'Professional & Scientific Activities' },
  { value: 'iso_14', label: 'Administrative & Support Services' },
  { value: 'iso_15', label: 'Public Administration & Defense' },
  { value: 'iso_16', label: 'Education' },
  { value: 'iso_17', label: 'Human Health & Social Work' },
  { value: 'iso_18', label: 'Arts, Entertainment & Recreation' },
  { value: 'iso_19', label: 'Other Service Activities' },
  { value: 'iso_20', label: 'Household Activities' },
  { value: 'iso_21', label: 'Extraterritorial Organizations' },
  
  // Additional Categories
  { header: 'Additional Categories' },
  { value: 'adult', label: 'Adult' },
  { value: 'arts', label: 'Arts & Culture' },
  { value: 'beauty', label: 'Beauty & Personal Care' },
  { value: 'books', label: 'Books & Literature' },
  { value: 'careers', label: 'Careers & Employment' },
  { value: 'celebrities', label: 'Celebrities & Entertainment' },
  { value: 'dating', label: 'Dating & Relationships' },
  { value: 'electronics', label: 'Electronics & Gadgets' },
  { value: 'environment', label: 'Environment & Sustainability' },
  { value: 'events', label: 'Events & Conferences' },
  { value: 'family', label: 'Family & Parenting' },
  { value: 'fashion', label: 'Fashion & Style' },
  { value: 'finance_personal', label: 'Personal Finance' },
  { value: 'fitness', label: 'Fitness & Exercise' },
  { value: 'gaming', label: 'Gaming' },
  { value: 'gardening', label: 'Gardening & Plants' },
  { value: 'gifts', label: 'Gifts & Occasions' },
  { value: 'government', label: 'Government & Politics' },
  { value: 'hobbies', label: 'Hobbies & Interests' },
  { value: 'home', label: 'Home & Interior' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'internet', label: 'Internet & Web' },
  { value: 'legal', label: 'Legal' },
  { value: 'marketing', label: 'Marketing & Advertising' },
  { value: 'medical', label: 'Medical & Health' },
  { value: 'movies', label: 'Movies & Film' },
  { value: 'music', label: 'Music' },
  { value: 'outdoors', label: 'Outdoors & Nature' },
  { value: 'pets', label: 'Pets & Animals' },
  { value: 'photography', label: 'Photography' },
  { value: 'recipes', label: 'Recipes & Cooking' },
  { value: 'religion', label: 'Religion & Spirituality' },
  { value: 'science', label: 'Science' },
  { value: 'software', label: 'Software & Apps' },
  { value: 'television', label: 'Television & Streaming' },
  { value: 'travel_destinations', label: 'Travel Destinations' },
  { value: 'vehicles', label: 'Vehicles & Transportation' },
  { value: 'weather', label: 'Weather & Climate' },
  { value: 'weddings', label: 'Weddings & Marriage' },
  
  // Other
  { value: 'general', label: 'General' },
  { value: 'other', label: 'Other' }
];

export default categoryOptions; 